// A peça de comprovantes das Multas e dos Sinistros. Coletada por glob em core/i18n/messages.ts.
export default {
  pt: {
    'comprovantes.soltar': 'Arraste os arquivos aqui ou clique para escolher',
    'comprovantes.regra': 'PDF, JPG, PNG, DOCX ou XLSX, até 5 MB cada, no máximo 10',
    'comprovantes.recusa.extensao': 'Formato não aceito',
    'comprovantes.recusa.legado': 'Salve como PDF, DOCX ou XLSX',
    'comprovantes.recusa.tamanho': 'Passa de 5 MB',
    'comprovantes.recusa.vazio': 'Arquivo vazio',
    'comprovantes.pendente': 'Sobe ao salvar',
    'comprovantes.enviando': 'Enviando',
    'comprovantes.erro': 'Não subiu',
    'comprovantes.abrir': 'Abrir',
    'comprovantes.baixar': 'Baixar',
    'comprovantes.remover': 'Remover',
    'comprovantes.tirar': 'Tirar da lista',
    'comprovantes.tentar': 'Tentar de novo',
    'comprovantes.nenhum': 'Nenhum comprovante',
  },
  en: {
    'comprovantes.soltar': 'Drop files here or click to choose',
    'comprovantes.regra': 'PDF, JPG, PNG, DOCX or XLSX, up to 5 MB each, at most 10',
    'comprovantes.recusa.extensao': 'Format not accepted',
    'comprovantes.recusa.legado': 'Save as PDF, DOCX or XLSX',
    'comprovantes.recusa.tamanho': 'Over 5 MB',
    'comprovantes.recusa.vazio': 'Empty file',
    'comprovantes.pendente': 'Uploads on save',
    'comprovantes.enviando': 'Uploading',
    'comprovantes.erro': 'Not uploaded',
    'comprovantes.abrir': 'Open',
    'comprovantes.baixar': 'Download',
    'comprovantes.remover': 'Remove',
    'comprovantes.tirar': 'Remove from list',
    'comprovantes.tentar': 'Try again',
    'comprovantes.nenhum': 'No receipts',
  },
  es: {
    'comprovantes.soltar': 'Arrastre los archivos aquí o haga clic para elegir',
    'comprovantes.regra': 'PDF, JPG, PNG, DOCX o XLSX, hasta 5 MB cada uno, máximo 10',
    'comprovantes.recusa.extensao': 'Formato no aceptado',
    'comprovantes.recusa.legado': 'Guarde como PDF, DOCX o XLSX',
    'comprovantes.recusa.tamanho': 'Supera 5 MB',
    'comprovantes.recusa.vazio': 'Archivo vacío',
    'comprovantes.pendente': 'Sube al guardar',
    'comprovantes.enviando': 'Enviando',
    'comprovantes.erro': 'No subió',
    'comprovantes.abrir': 'Abrir',
    'comprovantes.baixar': 'Descargar',
    'comprovantes.remover': 'Quitar',
    'comprovantes.tirar': 'Quitar de la lista',
    'comprovantes.tentar': 'Intentar de nuevo',
    'comprovantes.nenhum': 'Ningún comprobante',
  },
}
